import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api/financiero/sync-soportes";

const ejecutarSyncSoportes = async (usuario) => {
  const response = await axios.post(
    `${baseUrl}${endpoint}`,
    {},
    {
      headers: { usuario },
      timeout: 60000, // 🔥 evita cuelgues
    }
  );

  return response.data;
};

export {
  ejecutarSyncSoportes
};